export default __webpack_public_path__ + "static/media/phonebook.7fda41cb.jpg";